export const getHebel = store => store.hebel
